export default __webpack_public_path__ + "static/media/Thumb icon-02.45a7aee0.svg";